import React, { createContext, useState } from 'react'
import { useDispatch } from 'react-redux'
import { clearWorkoutTemplateOverrideWeightRecommendationStorage } from 'redux/slices/athleteProfile'

export const ModalKey = {
    Action: 'action',
    ActionWarning: 'action-warning',
    AssessmentInput: 'assessment-input',
    AssignGroupOwner: 'assign-group-owner',
    AssignRole: 'assign-role',
    AssignTrainer: 'assign-trainer',
    AthleteOffboard: 'athlete-offboard',
    BulkEditorOverride: 'bulk-editor-override',
    ComplianceConfiguration: 'compliance-configuration',
    CreateProgram: 'create-program',
    DeleteProgram: 'delete-program',
    EditAthleteMembership: 'edit-athlete-membership',
    EditEquipmentProfile: 'edit-equipment-profile',
    EditFitnessProfile: 'edit-fitness-profile',
    EditMacroVolumePhaseType: 'edit-macro-volume-phase-type',
    EditOrganizationBilling: 'edit-organization-billing',
    EventManagement: 'event-management',
    ExerciseAssessmentInfo: 'exercise-info-assessment',
    ExerciseInstructions: 'exercise-instructions',
    ExerciseLibrary: 'exercise-library',
    ExerciseSwap: 'exercise-swap',
    FileImport: 'file-import',
    IncompleteAthleteRecords: 'incomplete-athlete-records',
    InjuryInput: 'injury-input',
    KinesisEventV5: 'kinesis-event-v5',
    OrganizationDirectory: 'organization-directory',
    PlainTextEmailPreview: 'plain-text-email-preview',
    ProgramLevelScoreSelector: 'program-level-score-selector',
    ProgramWeekInfo: 'program-week-info',
    SelectExercise: 'select-exercise',
    SimulatorKinesisEvents: 'simulator-kinesis-events',
    SlotExerciseProgressionDetails: 'slot-exercise-progression-details',
    Text: 'text',
    TextAreaAction: 'text-area-action',
    TimelineColumnSettings: 'timeline-column-settings',
    VideoPlayer: 'video-player',
    WorkoutConfigWeekdayAssignmentOverrides: 'workout-config-weekday-assignment-overrides',
    WorkoutConfigWeekdayAssignments: 'workout-config-weekday-assignments',
    WorkoutLengthSelection: 'workout-length-selection',
    WorkoutOverride: 'workout-override',
    WorkoutSummary: 'workout-summary',
    WorkoutV5CompletedSummary: 'workout-v5-completed-summary',
    WorkoutV5IncompletePreview: 'workout-v5-incomplete-preview',
}

export const ModalContext = createContext()

export const ModalProvider = ({ children }) => {

    const dispatch = useDispatch()

    const [modalData, setModalData] = useState(null)

    const ShowModal = (modalData) => {

        if (modalData.key === ModalKey.WorkoutOverride) {
            dispatch(clearWorkoutTemplateOverrideWeightRecommendationStorage())
        }

        setModalData(modalData)
    }

    const HideModal = () => {
        setModalData(null)
    }

    const ModalContextData = {
        modalData,
        ShowModal,
        HideModal
    }

    return (
        <ModalContext.Provider value={ModalContextData}>
            {children}
        </ModalContext.Provider>
    )
}
